import { IAddress, IContact, IOrder } from '@topshots/core-models';

export const getShippingEmail = (order?: IOrder): string => {
  if (!order) return '';
  return order.shipping_email ?? (order?.contact_id as IContact)?.email ?? '';
};

export const getShippingLabel = (order?: IOrder): string => {
  const label = (address?: IAddress) => {
    if (!address) return '';
    return [
      address.organisation,
      address.line_1,
      address.line_2,
      address.line_3,
      address.line_4,
      address.town,
      address.county,
      address.postcode,
      address.country,
    ]
      .filter((i) => i && i?.trim() !== '')
      .join('<br />');
  };
  return (
    (order?.contact_id as IContact)?.full_name +
    '<br />' +
    (order?.shipping_address
      ? label(order.shipping_address)
      : (order?.contact_id as IContact)?.address
      ? label((order?.contact_id as IContact)?.address)
      : '')
  );
};
